import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ComissaoService } from '../comissao.service';
import { ComissaoVendedor } from '../models/comissao';

@Component({
  selector: 'app-comissao-list',
  templateUrl: './comissao-list.component.html',
  styleUrls: ['./comissao-list.component.scss']
})
export class ComissaoListComponent implements OnInit {

  public dataInicio: Date = new Date();
  public dataFim:  Date = new Date();
  public data:  Date = new Date();
  public msg: string = ""; 
  public displayModal: boolean;

  constructor(private comissaoService: ComissaoService, private router: Router, private route: ActivatedRoute, private activateRoute: ActivatedRoute) {

    this.data.setDate(this.data.getDate() - 30);
    this.dataInicio = this.data;
    
   }

  public listaComissaoVendedor: ComissaoVendedor[];

  ngOnInit(): void {    
    this.getComissaoVendedor();
  }

  getComissaoVendedor() {
      this.comissaoService.getComissaoVendedor(this.dataInicio , this.dataFim).subscribe(      
      (res) => {
        if (res) {
          this.listaComissaoVendedor = res;          
        }
      },
      err => {
        console.log("ComissaoList - Vendedor");
        console.log(err);
      }
    );
  }

  printRelComissaoVendedor(idUsuario: number) {        
    this.router.navigate(['/comissao-list-pdf',idUsuario, this.dataInicio.toDateString(), this.dataFim.toDateString()]);    
  }

  editPedido(idPedido: number) {
    this.router.navigate(['/pedido', idPedido])
  }


}
